export const TELEPHONIC_ENTRY_ERROR_MESSAGES = {
  casiError:
    'Failed to call Convenient Checkout Gateway telephonic-entry endpoint. Please try again.',
  sycurioIframeError:
    'Failed to load secure form. Please try again.',
  expiryError: 'Please enter a valid expiry date.',
  submitError: 'Failed to submit form. Please try again.',
  telephonicEntryMaxAttemptsReached:
    'Maximum number of retries reached. Please try a different capture method.',
};
